import { localeData } from '../../../locales/data';
import { PasswordGenerator } from '../../../components';
import * as React from 'react';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import Immutable from 'immutable';
import { VALIDATION_DIVIDER_STRING } from '../wizard/validations';

import { useWizardFormController } from '../wizard/formHelpers';
import { PasswordGeneratorProps as PasswordGeneratorPropsOriginal } from '../../../components/Forms/Password/PasswordGenerator/PasswordGenerator';
import { PasswordGuideline } from '../../../components/Forms/Password/PasswordGuidelines/PasswordGuidelines';
import { WizardControllerProps } from './types';
import { UseFormReturn } from 'react-hook-form/dist/types';

interface PasswordGeneratorProps {
  controllerProps: WizardControllerProps & { form: UseFormReturn<any> };
  inputProps?: {
    guidelines?: PasswordGuideline[];
    autocomplete?: string;
  };
}

export const PasswordGeneratorField = ({ controllerProps, inputProps }: PasswordGeneratorProps) => {
  const controller = useWizardFormController({ ...controllerProps });
  const intl = useIntl();

  const { value, name, onChange, onBlur } = controller.field;

  // when we press on generate button, click event is dispatched with data as second argument
  const onPasswordChange: PasswordGeneratorPropsOriginal['handleChange'] = (event, data) => {
    if (event.type === 'click') {
      onChange({ target: { value: data.value } });
    } else {
      onChange(event);
    }
    controllerProps.form.trigger(controllerProps.name);
  };

  const { error } = controller.fieldState;
  const passwordErrors = useMemo(() => Immutable.List(error?.message?.split?.(VALIDATION_DIVIDER_STRING) ?? []), [error]) as any;

  return (
    <PasswordGenerator
      label={intl.formatMessage({ id: 'password.label', defaultMessage: localeData.en['password.label'] })}
      name={name}
      value={value}
      handleChange={onPasswordChange}
      handleBlur={onBlur}
      errors={passwordErrors}
      id={name}
      modifiers={['create-account']}
      contentModifiers={['create-account']}
      required={true}
      autoComplete={inputProps?.autocomplete}
      guidelines={inputProps?.guidelines}
      gaGenerateEvent="wizard_sign_up_click_password_generator"
    />
  );
};
